// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

module.exports = angular
  .module('bench.config.hotkeys', deps)

  // Expose key press as an event.
  .run(($document, $rootScope) => {
    $document.bind('keyup', e => $rootScope.$broadcast('blKeyup', e));

    return $document.bind('keydown', e => $rootScope.$broadcast('blKeydown', e));
  });
